export function isRegistrationPendingAccount(account) {
  return account?.settings?.registration_status === 'pending_approval';
}

export async function ensureAccountRecord(store, accountId) {
  if (!accountId) return null;

  let account = store.getters['accounts/getAccount'](accountId);
  if (!account?.settings) {
    await store.dispatch('accounts/get');
    account = store.getters['accounts/getAccount'](accountId);
  }
  return account;
}
